import { React, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";

import usersService from "../../../../../services/userService";

import NotificationDropdown from "../../NotificationDropdown/NotificationDropdown";
import ParentDropdown from "../../HeaderDropdowns/ParentDropdown";
import { Button } from "../../../Buttons";

function ParentHeaderNavDesktop({ userInfo }) {
  const { t } = useTranslation();
  const [notificationDropdown, setNotificationDropdown] = useState(false);
  const [userDropdown, setUserDropdown] = useState(false);

  const notificationClasses = classNames(
    "navButton navButtonDrop hasIcon--mail withoutText",
    {
      active: notificationDropdown,
    }
  );

  return (
    <>
      <nav>
        <Button
          customClassName="navButton withoutText"
          iconClassName="hasIcon--grid"
          onClick={() => usersService.goToMonolith("accounts/readers/")}
        />

        <Button
          customClassName="navButton withoutText"
          iconClassName="hasIcon--book-open"
          onClick={() => usersService.goToMonolith("moms-library/")}
        />

        <a
          href="https://bluemanoreducation.com/product-category/blue-manor-print-books/"
          target="_blank"
          rel="noreferrer noopener"
          className="navButton navButtonLink hasIcon--shopping-cart withoutText"
          title={t("bookStore")}
        >
        </a>

        <OutsideClickHandler
          onOutsideClick={() => setNotificationDropdown(false)}
        >
          <section
            onClick={() => usersService.goToMonolith("mail/students_emails/")}
            className={notificationClasses}
            title={t("notifications")}
          >
            {userInfo?.new_emails_and_notifications_count > 0 && (
              <div className="menu-counter">
                {userInfo?.new_emails_and_notifications_count}
              </div>
            )}
            {notificationDropdown && (
              <NotificationDropdown
                notifications={userInfo?.notifications?.notifications}
              />
            )}
          </section>
        </OutsideClickHandler>

        <OutsideClickHandler onOutsideClick={() => setUserDropdown(false)}>
          <section
            onClick={() => setUserDropdown(!userDropdown)}
            className={
              "navButton navButtonDrop withoutText userAvatar hasIcon--user"
            }
            title={userInfo?.name}
          >
            {userDropdown && <ParentDropdown userInfo={userInfo} />}
          </section>
        </OutsideClickHandler>
      </nav>
    </>
  );
}

export default ParentHeaderNavDesktop;
